export default "__VITE_ASSET__CuoTlHg___"